import { render, staticRenderFns } from "./RefsCustomerAccount.vue?vue&type=template&id=0112b35e&scoped=true"
import script from "./RefsCustomerAccount.vue?vue&type=script&lang=ts"
export * from "./RefsCustomerAccount.vue?vue&type=script&lang=ts"
import style0 from "./RefsCustomerAccount.vue?vue&type=style&index=0&id=0112b35e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0112b35e",
  null
  
)

export default component.exports